import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const images = [
  "https://img.freepik.com/premium-photo/education-back-school-concept_93675-15227.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid",
  "https://img.freepik.com/free-photo/front-view-little-globe-with-copybooks-pencils-yellow-surface_140725-63984.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid",
  "https://img.freepik.com/free-vector/children-outside-school-scene_1308-31442.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid",
  "https://img.freepik.com/premium-vector/cute-panda-go-school_29190-1681.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid",
  "https://img.freepik.com/free-photo/workspace-with-blackboard-book-stationery_23-2147849992.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid",
  "https://img.freepik.com/free-vector/scene-with-many-children-learning-classroom_1308-40057.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid",
  "https://img.freepik.com/premium-photo/back-school_182029-641.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid"
];

const Gallery = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
            AOS.init({ duration: 1000 }); 
        }, []);
  return (
    <div className="container mx-auto px-6 py-12">
      <h1 className="text-3xl font-bold text-center mb-6" data-aos="fade-up">Gallery</h1>
      <div className="columns-3 gap-2 space-y-2" data-aos="fade-up">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Gallery ${index + 1}`}
            className="w-auto h-auto block transform transition duration-300 hover:scale-105"
            data-aos="fade-up"
          />
        ))}
      </div>
    </div>
  );
};

export default Gallery;
